module.exports = __webpack_public_path__ + "static/img/guy-avatar@3x.c603037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cx-avatars/guy-avatar@3x.png
// module id = gWhh
// module chunks = 6